// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import 'src/scripts/vendor/slick.min'
import 'src/scripts/modules/globalslide.js'
import 'src/scripts/modules/form.js'
import 'src/scripts/modules/slider.js'
